import * as React from 'react';
import {FunctionComponent} from 'react';
import {CalendarMode} from '../EventCalendarPresenter';
import {CalendarEvent} from '../../../../Models/CalendarEvent';
import {FullCrew} from '../../../../Models/Crew';
import {Calendar} from './Calendar/Calendar';
import {RsvpCalendar} from './Rsvps/RsvpCalendar';
import {WeeklyCalendar} from './WeeklyCalendar/WeeklyCalendar';
import {PartialWorkout} from '../../../../Models/PartialWorkout';

interface OwnProps {
    mode: CalendarMode;
    referenceDate: Date;
    ownWorkouts: PartialWorkout[];
    calendarEvents: CalendarEvent[];
    crews: FullCrew[];
    onCalendarEventClick: (calendarEvent: CalendarEvent) => void;
    onCalendarEventDateChange: (calendarEvent: CalendarEvent, date: Date) => void;
    onCreateClick: (date: Date) => void;
}

export const BigScreenModes: FunctionComponent<OwnProps> = ({
    mode,
    referenceDate,
    ownWorkouts,
    calendarEvents,
    crews,
    onCalendarEventClick,
    onCalendarEventDateChange,
    onCreateClick,
}) => {
    switch (mode) {
        case CalendarMode.Month:
            return (
                <Calendar
                    referenceDate={referenceDate}
                    ownWorkouts={ownWorkouts}
                    calendarEvents={calendarEvents}
                    onCalendarEventDateChange={onCalendarEventDateChange}
                    onCalendarEventClick={(event) => {
                        onCalendarEventClick(event);
                    }}
                    onCreateClick={(date) => {
                        onCreateClick(date);
                    }}
                />
            );
        case CalendarMode.Rsvp:
            return (
                <RsvpCalendar
                    referenceDate={referenceDate}
                    calendarEvents={calendarEvents}
                    crews={crews}
                    onCalendarEventClick={(event) => {
                        onCalendarEventClick(event);
                    }}
                />
            );
        case CalendarMode.Week:
            return (
                <WeeklyCalendar
                    referenceDate={referenceDate}
                    calendarEvents={calendarEvents}
                    onCalendarEventClick={(calendarEvent) => {
                        onCalendarEventClick(calendarEvent);
                    }}
                    onCreateClick={(date) => {
                        onCreateClick(date);
                    }}
                />
            );
    }
};
